module.exports = __webpack_public_path__ + "static/media/volontaria-giurisdizione.40869670.jpg";